import { apiGet } from 'api';
import { Consultation } from 'types';

export const getConsultation = (id: number): Promise<Consultation> =>
  apiGet<Consultation>(`consultations/${id}`);
